import React, { Component } from 'react';
import { AuthContext } from "./../../context/auth";
import { NavLink } from "react-router-dom";

class bottomNavComponent extends Component{
    static contextType = AuthContext;
    render() {
        return (
            <div className="bottom-navigation">
                <div className="bottom-navigation-wrapper" role="navigation">
                    <ul className="">
                        <li className="bottomlink-container active">
                            <NavLink exact to={`${process.env.PUBLIC_URL}/`} className="routing-link">
                                <div className="icon--house homeico"><i className="fa fa-home"></i></div>
                                <span>Home</span>
                            </NavLink>
                        </li>
                        <li className="bottomlink-container">
                            <NavLink exact to={`${process.env.PUBLIC_URL}/search`} className="routing-link">
                                <div className="icon--house searchico"><i className="fa fa-search"
                                                                          aria-hidden="true"></i></div>
                                <span>Search</span>
                            </NavLink>
                        </li>
                        <li className="bottomlink-container">
                            {this.context.authenticated ?
                                <NavLink exact to={`${process.env.PUBLIC_URL}/profile`} className="routing-link mobile-profile">
                                    <div className="icon--house profileico"><i className="fa fa-user-o"
                                                                               aria-hidden="true"></i></div>
                                    <span>Profile</span>
                                </NavLink>
                                :
                                <NavLink exact to={`${process.env.PUBLIC_URL}/login`} className="routing-link mobile-profile">
                                    <div className="icon--house profileico"><i className="fa fa-user-o"
                                                                               aria-hidden="true"></i></div>
                                    <span>Login</span>
                                </NavLink>
                            }
                        </li>
                    </ul>
                </div>
            </div>
        )
    }
}

export default bottomNavComponent;